module.exports = __webpack_public_path__ + "static/media/nutria_tex.7b240bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/nutria/nutria_tex.png
// module id = 136
// module chunks = 0